import React, { Component, PropTypes } from 'react';
import RulerBar from 'components/RulerBar';
import { mixin, RefluxMixin } from 'Util';
import AppPage from 'components/AppPage';
import Message from 'services/Message';
import { history } from 'helpers';
import { StoreStore, AuthStore } from 'stores';
import { StoreActions } from 'actions';
import Config from 'Config';
import Loader from 'components/Material/Loader';
import StoreBar from 'components/StoreBar';
import ScrollableContainer from 'components/ScrollableContainer';

const isNumeric = value => !isNaN(parseFloat(value)) && isFinite(value);

const pageLookup = {
  course: 'courseExplanation',
  tac: 'termsAndConditions',
  support: 'support'
};

const css = oxygenCss({
  content: {
    width: 960,
    maxWidth: '100%',
    boxSizing: 'border-box',
    padding: 64,
    margin: 'auto'
  }
});

export default class About extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    router: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStoreWithMapper(
      StoreStore,
      state => {
        return {
          docs: state.docs || {},
          logo: state.theme && state.theme.logoUrl,
          title: state.owner && state.owner.name,
          username: state.owner && state.owner.username
        };
      },
      {
        docs: {}
      }
    );
    this.listenToStoreWithMapper(
      AuthStore,
      state => ({
        locale: state.locale
      }),
      {
        locale: 'en_US'
      }
    );
  }

  componentDidMount() {
    const domain = /:\/\/([^\/]+)/.exec(window.location.href)[1];
    let subDomain;
    if ('//' + domain !== Config.thisHost) {
      subDomain = domain.split('.').shift();
    }

    let { username } = this.props.routeParams;
    if (subDomain && !isNumeric(subDomain)) {
      username = subDomain;
    } else if (!username && AuthStore.isAuthenticated()) {
      username = AuthStore.getUser().username;
    }
    if (username !== this.state.username) {
      StoreActions.read(username, true);
    }
  }

  renderToCSwedish() {
    return (
      <div>
        <h1>Användarvillkor (2013-10-18)</h1>
        <h2>1. Tjänsten</h2>
        <p>
          Villkor vid köp av kurs eller guide som är framtagen med hjälp av
          Coursios tjänst.
        </p>
        <p>
          Coursio är en tjänst för att skapa webbaserade kurser och guider som
          distribueras elektroniskt. Tjänsten möjliggör företag att skapa skapa
          online kurser bestående av video, text, bilder, ljud och interaktiva
          funktioner. I tjänsten ingår hosting och driftande av plattformen,
          support och i vissa fall även en webshop för presentation och
          försäljning av kurserna.
        </p>
        <p>
          Coursio reserverar sig rätten att ändra dessa villkor på denna sida
          och villkoren kommer appliceras 30 dagar från uppdateringen.
        </p>
        <p>
          Efter att ha genomfört köpet av en guide eller kurs som producerats
          med Coursios tjänst och via de presentationssidor som framtagits av
          Coursios verktyg får du tillgång till materialet. Vid genomförandet av
          köpet registrerar du ett kundkonto för att ta del av material via
          Coursios tjänst eller använder ett tidigare registrerat konto. När
          köpet gått igenom kommer du in i Coursios tjänst och tar del av
          materialet. För att framöver komma åt materialet loggar du in via
          sidan http://app.coursio.com.
        </p>
        <p>
          Skapande av kundkonto medges endast den som har en giltig
          e-postadress. Du ansvarar för att den e-postadress som angivits är
          riktig och aktiv. Du kan själv ändra den angivna e-postadressen under
          “Inställningar”.
        </p>
        <p>För att registrera dig i Coursio ska du ha fyllt 18 år.</p>
        <h2>2. Betalning</h2>
        <p>
          Då köpet sker genom en presentationssida som framtagits av Coursios
          verktyg finns två betalningsalternativ:
        </p>
        <p>Alt 1. Klarna, Faktura och Kort</p>
        <p>
          Coursio erbjuder i samarbete med Klarna fakturering till
          privatpersoner och företag, med betalningsvillkor 14 dagar. Faktura
          sänds ut via e-mail och du betalar enkelt till BankGiro. Betalning mot
          faktura sker enbart till folkbokförd (privatperson) eller registrerad
          (företag) adress. Kontakta Klarna på telefon 08-120 120 00 om du har
          frågor angående betalning. Vid försenad betalning utgår
          påminnelseavgift med det belopp som är tillåtet enligt. Vid frågor
          rörande påminnelseavgift/räntor, kontakta Klarna. Förenklad
          kreditprövning utan kännedomskopia sker. Genom Klarna finns också
          möjlighet till betalning via kort.
        </p>
        <p>Alt 2. Kortbetalning via Net Payments</p>
        <p>
          Coursio erbjuder i samarbete med NetPayments kortbetalning. Kort som
          fungerar är Visa och Mastercard. Net Payments använder sig av
          3D-secure vilket är den säkerhetsgrad som de svenska bankerna kräver.
        </p>
        <h2>3. Ångerrätt</h2>
        <p>
          Då du köper tillgång till en tjänst gäller inte distanshandelslagen.
          Då betalningen gått igenom och du fått tillgång till materialet anses
          ångerrätten förbrukad. Ångerrätten gäller inte heller defekta eller
          felaktiga varor. Är produkten defekt eller felaktig är du istället
          välkommen att kontakta vår kundservice och göra en reklamation på
          support@coursio.com
        </p>
        <h2>4. Tekniska förutsättningar</h2>
        <p>
          Tjänsten kräver tillgång till internet. Du ansvarar själv för de
          kostnader som uppstår i användandet av internetuppkoppling.
        </p>
        <h2>5. Ansvar</h2>
        <p>
          Vid köp av en kurs eller guide gäller tillgången till materialet
          endast för den personen som har köpt det. Du får inte på något sätt
          sprida vidare innehållet till andra eller dela lösenord till ditt
          konto.
        </p>
        <h2>6. Coursio</h2>
        <p>
          Mateiral köpt via Coursio finns tillgängligt dygnet runt, sju dagar i
          veckan. Coursio ger dock inga garantier för att tjänsten alltid är fri
          från fel eller avbrott. Om brister eller avbrott i tjänsten uppstår
          skall Corusio ges möjlighet att rätta till dessa utan att avtalsbrott
          skall anses föreligga. Coursio har också rätt att, i rimlig
          omfattning, stänga tjänsten för till exempel uppgraderingar och
          service.
        </p>
        <h2>7. Ansvarsfriskrivning</h2>
        <p>
          Coursio är en tjänst för att publicera material i form av kurser och
          guider. Genom tjänsten kan Coursios kunder sälja kurser och guider
          antingen via sina egna hemsidor, andra försäljningskanaler eller i de
          fall de vill via en presentationssida som ingår i Coursios tjänst. I
          de fall försäljningen sker via denna sida sköts betalningen via
          Coursios konton på Klarna och Net Payments. Coursio är inte ansvariga
          för dispyter, krav, förluster, eller skador av något slag som kan
          uppstå ur handlingar eller information som genomförs och delas av
          kunder till Coursio eller deltagare i kundernas kurser och guider.
        </p>
        <p>
          Vi kontrollerar inte innehållet i de material som läggs upp av våra
          kunder och garanterar inte på något sätt tillförligtligheten,
          giltigheten, nogrannheten eller korrektheten i innehållet. Som köpare
          av kurser eller guider medger du att du kan exponeras för stötande
          eller olämpligt innehåll och förstår att Coursio bär inget ansvar för
          att hålla dig borta från denna typ av innehåll och tar inget ansvar
          för innehållet i sig.
        </p>
        <p>
          Via Coursio kan du få tillgång till länkar till tredje parts sidor
          antingen genom verktyget i sig eller material som kunder lagt upp.
          Coursio tar inget ansvar för dessa tredje parts sidor och kontrollerar
          inte dem på något sätt. Som användare i Coursio bör du ta lämpliga
          åtgärder för att bedöma om det är lämpligt att besöka en sådan tredje
          parts sida och skydda din egna personliga information och integritet
          på en sådan sida.
        </p>
        <h2>8. Lagval</h2>
        <p>
          Tvist enligt dessa villkor skall avgöras enligt svensk lag i
          Stockholms Tingsrätt.
        </p>
        <p>
          Frågor kring dessa villkor riktas till Coursio AB, Tegnérgatan 1, 111
          40 Stockholm eller info@coursio.se.
        </p>
        <p>Personuppgifter – hur dom hanteras och används</p>
        <p>
          För att registrera sig i Coursios tjänst krävs endast e-mail adress
          och För och Efternamn. När du uppger dina personuppgifter hos oss
          godkänner du att vi lagrar och använder dina uppgifter i vår
          verksamhet för att fullfölja avtalet gentemot dig. I detta ingår att
          vi kommer informera dig om uppdateringar som sker i de material du har
          tillgång till och om generella uppdateringar i tjänsten.
        </p>
        <p>
          Du medger också att vi delar denna persondata med den kund som är
          avsändare för kursen eller guiden som skapats med hjälp av Coursio.
          Vem kunden är framgår av vem som är skapare av kursen eller guiden du
          fått tillgång till. Dessa kunder får använda denna information för att
          kontakta dig i anslutning till kursen som du har tillgång till.
          Kunderna kan också använda dessa uppgifter i andra syften. Det är ditt
          ansvar som användare att säkerställa vad Kunden kommer att göra med
          denna information och hur den kommer att lagras. Coursio kontrollerar
          inte användningsområdena eller hur den här informationen lagras av
          våra Kunder.
        </p>
        <p>
          Vid avregistrering av ditt Coursio konto kommer Coursio radera alla
          uppgifter om dig. Det är dock ditt ansvar att säkerställa att så även
          sker hos de Kunder som du köpt material av. Du har rätt att
          skriftligen utan kostnad begära ett registerutdrag eller
          rättelse/radering av eventuellt felaktiga uppgifter om dig. Du kan
          också spärra uppgifterna mot marknadsföring.{' '}
        </p>
      </div>
    );
  }

  renderToCEnglish() {
    return (
      <div>
        <h1>Terms (2013-10-18)</h1>
        <h2>The service</h2>
        <p>
          The course or the guide are developed with the help of oursio’s
          service. Coursio is a service for creation of web-based courses and
          guides that are distributed electronically. The service allows
          businesses to create create online courses consisting of video, text,
          images, audio, and interactive features. The service includes hosting
          and operating the spirit of the platform, support and in some cases
          even a shop for the sale and presentation of the courses.
        </p>
        <p>
          Coursio reserves the right to change these terms and conditions on
          this page and the conditions will be applied 30 days following the
          update.
        </p>
        <p>
          After having completed the purchase of a guide or course produced by
          Coursio’s service and through the presentation page developed by
          Coursio’s tool, you will be given access to the material. As a part of
          purchase process, you register a customer account to study the
          material through Coursio’s service or use a previously registered
          account. When the purchase is processed, you will enter Coursio’s
          services and can view the material. To access the material please log
          in through the site http://app.coursio.com.
        </p>
        <p>
          Creation of customer account is permitted only with a valid email
          address. You are responsible for the email address stated is correct
          and active. You can change the email address stated under “Settings”.
        </p>
        <p>To register in Coursio you must be over 18 years.</p>
        <h2>2. Payment</h2>
        <p>To purchase the course you have 2 options:</p>
        <p>Option 1. Payment via the Net Payments</p>
        <p>
          Coursio offers a cooperation with NetPayments card payments. Cards
          that work is Visa and MasterCard. Net Payments uses 3D-Secure, which
          is the level of security that the Swedish banks require.
        </p>
        <p>Option 2. Paypal</p>
        <p>Coursio offers payment through your Paypal account.</p>
        <h2>3. Returns</h2>
        <p>
          When you buy a course or a guide, the purchase does not apply to
          e-commerce law. When the payment has been processed and you got access
          to material, your right to withdrawal is exhausted. Is the product
          defective or incorrect, you are welcome to contact our customer
          service department at support@coursio.com.
        </p>
        <h2>4. Technical conditions</h2>
        <p>
          The service requires access to the Internet. You are responsible for
          the costs incurred in the use of internet.
        </p>
        <h2>5. Responsibility</h2>
        <p>
          When buying a course or a guide access is only granted to the person
          who bought it. You may not in any way spread further content to others
          or share the password to your account.
        </p>
        <h2>6. Coursio</h2>
        <p>
          Material purchased through Coursio is available around the clock,
          seven days a week. Coursio, however, no guarantee that the service is
          always free of errors or interruptions. If the deficiencies or
          interruption in service occurs, the Coursio reserves the right to
          correct them without breach of contract. Coursio also reserves the
          right, with reason, to close the service for upgrades and maintenance.
        </p>
        <h2>7. Disclaimer</h2>
        <p>
          Coursio is a service to publish material in the form of courses and
          guides. Through the service, customers Coursio’s sell courses and
          guides, either through their own websites, other sales channels or
          where a presentation page is included in Coursio’s service. Sales are
          made through this page are managed payment via Coursios accounts at
          Paypal and Net Payments. Coursio is not responsible for any disputes,
          claims, losses, or damages of any kind that may arise from documents
          or information that are implemented and shared by customers Coursio or
          participants in customer courses and guides.
        </p>
        <p>
          We do not control the content of the materials submitted by our
          customers and do not guarantee in any way validity or accuracy of the
          content. As a buyer of courses or guides you acknowledge that you may
          be exposed to offensive or inappropriate content and understand that
          Coursio bears no responsibility of this type of content and assume no
          responsibility for the content itself.
        </p>
        <p>
          Via Coursio you can access links to third party sites either by the
          tool itself or the material that clients has provided. Coursio take no
          responsibility for these third-party sites and do not control them in
          any way. As a user of Coursio should take appropriate steps to assess
          whether it is advisable to visit such third party site and protect
          your own personal information and privacy at such a page.
        </p>
        <h2>8. Freedom of choice</h2>
        <p>
          Any dispute under these terms shall be governed by Swedish law in the
          Stockholm District Court.
        </p>
        <p>
          Questions regarding this statement, addressed to Coursio AB,
          Tegnérgatan 1, 111 40 Stockholm, or info@coursio.se.
        </p>
        <h2>9. Personal data</h2>
        <p>
          To register in Coursios service requires only the e-mail address and
          first and last name. When you provide your personal details, you agree
          that we store and use your information in our business to fulfill the
          contract against you. In this part we will inform you of updates that
          occur in the material you have access and for general updates to the
          service.
        </p>
        <p>
          You also admit that we share this personal data with the customer who
          is the provider of the course content. These customers may use this
          information to contact you for other purposes. It is your
          responsibility as a user to ensure what the customer will do with this
          information and how it will be stored. Coursio not control the uses or
          how this information is stored by our Customers.
        </p>
        <p>
          Upon deregistration of your Coursio account will Coursio delete all
          information of you. However, it is your responsibility to inform the
          Customers whose material you have purchase is well. You have the right
          to request a deregistration, correction of potentially wrong data in
          regards to you. This has to be done in via email to
          support@coursio.com. You can also lock the access of your user data
          for marketing done by the Customer.{' '}
        </p>
      </div>
    );
  }

  render() {
    const { page } = this.props.params;
    const { getIntlMessage } = this.context;
    const { docs, logo, title, locale } = this.state;
    let pageContent;
    const content = docs[pageLookup[page]];
    if (!content) {
      if (page === 'tac') {
        if (locale === 'sv_SE') {
          pageContent = this.renderToCSwedish();
        } else {
          pageContent = this.renderToCEnglish();
        }
      } else if (page === 'support') {
        pageContent = (
          <div
            dangerouslySetInnerHTML={{
              __html: getIntlMessage('about.support')
            }}
          />
        );
      }
    } else {
      pageContent = <div dangerouslySetInnerHTML={{ __html: content }} />;
    }
    if (!title) {
      return <Loader />;
    }
    return (
      <AppPage
        header={<StoreBar logo={logo} title={title} />}
        className={'about'}
      >
        <ScrollableContainer>
          <div className={css.content}>{pageContent}</div>
        </ScrollableContainer>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/About.js